import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from '../../constants';

const AppRouter = (): JSX.Element => <RouterProvider router={router} />;

export default AppRouter;
